module.exports = __webpack_public_path__ + "img/1f919.a2a8a04.svg";